<template>
    <layout title="Drive Calendar">
            <v-row>
                <v-col cols="3">
                  <ScheduledDrivers></ScheduledDrivers>
                </v-col>
                <v-col cols="6">
                    <v-card flat outlined tile>

                        <v-card-text class="pa-0">
                            <v-calendar
                                    v-model="focus"
                                    color="primary"
                                    ref="calendar"
                                    type="month"
                                    :now="controls.today"
                            ></v-calendar>

                            <v-card-actions>
                                <v-btn fab small outlined @click="prevMonth">
                                    <v-icon>chevron_left</v-icon>
                                </v-btn>
                                <v-spacer></v-spacer>
                                <div class="display-1">{{title}}</div>
                                <v-spacer></v-spacer>
                                <v-btn fab small outlined @click="nextMonth">
                                    <v-icon>chevron_right</v-icon>
                                </v-btn>
                            </v-card-actions>
                            <v-toolbar dense flat>
                                <v-spacer></v-spacer>
                                <RecurringCustomers :recurring="queried.scheduled_recurring" :names="queried.names"></RecurringCustomers>
                                <v-spacer></v-spacer>
                                <Tools :routes="queried.routes" :names="queried.names">
                                    <template v-slot:activator="{on}">
                                        <v-btn v-on="on" small tile outlined>
                                            Tools
                                        </v-btn>
                                    </template>
                                </Tools>

                                <v-spacer></v-spacer>
                                <CreateRoute :routes="queried.routes" editing/>
                                <v-spacer></v-spacer>
                                <CreateRoute/>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                            <v-divider></v-divider>
                            <v-card-text>
                                <v-data-table
                                        v-if="queried.routes"
                                        :headers="[{text: 'name', value: 'name'},{text: 'name', value: 'name'}, {text: 'actions', value: 'action'}]"
                                        :items="routes"
                                        item-key="id"
                                        hide-default-header
                                        disable-pagination
                                        hide-default-footer
                                        show-expand
                                >
                                  <template v-slot:item.action="{item}">
                                    <td class="text-right" style="width:1%;white-space:nowrap;">
                                      <AddToRoute @showLocation="$refs.map.addLatLonMarker($event)" :route="item" :date="focus" :day="day">
                                        <template v-slot:activator="{on:dialog}">
                                          <v-tooltip bottom>
                                            <template v-slot:activator="{on: tooltip}">
                                              <v-btn v-on="{...tooltip, ...dialog}" color="success" icon outlined><v-icon>add</v-icon></v-btn>
                                            </template>
                                            <span>Add Pickup</span>
                                          </v-tooltip>
                                        </template>
                                      </AddToRoute>
                                      <ScheduleDriver>
                                        <template v-slot:activator="{on:dialog}">
                                          <v-tooltip bottom>
                                            <template v-slot:activator="{on:tooltip}">
                                              <v-btn v-on="{...tooltip, ...dialog}" class="ml-2" color="blue" icon outlined>
                                                <v-icon>mdi-truck</v-icon>
                                              </v-btn>
                                            </template>
                                            <span>Schedule Driver</span>
                                          </v-tooltip>
                                        </template>
                                      </ScheduleDriver>

                                      <v-tooltip bottom>
                                        <template v-slot:activator="{on}">
                                          <v-btn @click="$store.dispatch('showSuccess', 'Email Sent!')" v-on="on" class="ml-2" color="secondary" icon outlined>
                                            <v-icon>mdi-email</v-icon>
                                          </v-btn>
                                        </template>
                                        <span>Notify Driver</span>
                                      </v-tooltip>
                                    </td>
                                  </template>

                                  <template v-slot:expanded-item="{item}">
                                    <td colspan="4">
                                      <template v-for="cust in scheduled.filter(c => { return (c.date && c.date === focus) || (c.days && c.days[day])})">
                                        <ScheduledCustomer @showLocation="$refs.map.addLatLonMarker($event)" :route_item="cust" :name="queried.names.find(name => name.customer_id === cust.customer_id).name"></ScheduledCustomer>
                                      </template>
                                    </td>
                                  </template>
                                </v-data-table>
                            </v-card-text>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="3">
                    <Map ref="map"></Map>
                </v-col>
            </v-row>
    </layout>
</template>

<script>
    import moment from 'moment';
    import firebase from 'firebase/app';
    import 'firebase/firestore';
    import belit from '../../Lib/Belit';
    export default {
        name: "index",
        components:{
            ScheduleDriver: () => import('./components/ScheduleDriver'),
            CreateRoute: () => import('./components/CreateRoute'),
            AddToRoute: () => import('./components/AddToRoute'),
            ScheduledCustomer: () => import('./components/ScheduledCustomer'),
            Tools: () => import('./Tools/Tools'),
            Map: () => import('./components/Map'),
            RecurringCustomers: () => import("./components/RecurringCustomers"),
            ScheduledDrivers: () => import("./components/ScheduledDrivers")

        },
        data: () => ({
            controls:{
                today: moment().format("YYYY-MM-DD"),
            },
            focus: moment().format("YYYY-MM-DD"),
            queried:{
                routes:null,
                scheduled: null,
                scheduled_recurring: null,
                names: null,
            },
            realtimeQueries:{
                routes: null,
                scheduled: null,
                names: null,
                scheduled_recurring: null
            }
        }),
        computed:{
            title(){
                let date = moment(this.focus);
                return date.format("MMMM Do YYYY")
            },
            routes(){
              return this.queried.routes;
            },
            scheduled(){
                return [...this.queried.scheduled.filter(scheduled => !this.queried.scheduled_recurring.find(s => scheduled.customer_id === s.customer_id && s.days[this.day])), ...this.queried.scheduled_recurring]
            },
            day(){
                let date = moment(this.focus);
                return  date.format('dddd').toLowerCase();
            }
        },
        mounted(){
            this.listenToRoutes();
            this.listenToScheduled();
            this.listenToScheduledRecurring();
            this.getNames();

        },
        watch: {
          focus(){
            this.listenToRoutes();
            this.listenToScheduled();
            this.listenToScheduledRecurring();
          }
        },
        methods:{
            async getNames(){
                let response = await belit.get('/names', {
                    // where:{
                    //     value: 1,
                    //     key: "name_type_id"
                    // }
                  where:{
                    value: 90,
                    key: "customer_id"
                  }
                });
                this.queried.names = response.data;
            },
            listenToScheduled(){
                if(this.realtimeQueries.scheduled){
                  this.realtimeQueries.scheduled();
                  this.realtimeQueries.scheduled = null;
                  this.queried.scheduled = [];
                }
                this.realtimeQueries.scheduled = this.$firestore.collection('scheduled').where("date", "==", this.focus).onSnapshot(snapshot => {
                    if(!this.queried.scheduled){
                        this.queried.scheduled = [];
                    }
                    snapshot.docChanges().forEach(change => {
                        let schedule = change.doc.data();
                        console.log('change');
                        if(change.type === "removed"){
                            let index = this.queried.scheduled.findIndex(v => v.id === change.doc.id);
                            this.queried.scheduled.splice(index, 0);
                        }else if(change.type === "modified"){
                            console.log('modded');
                            let index = this.queried.scheduled.findIndex(v => v.id === change.doc.id);
                            this.$set(this.queried.scheduled,index, {id: change.doc.id, ...schedule});
                        }else if(change.type === "added"){
                            this.queried.scheduled.push({id: change.doc.id, ...schedule})
                        }
                    })
                })
      },
          listenToScheduledRecurring(){
            if(this.realtimeQueries.scheduled_recurring){
              this.realtimeQueries.scheduled_recurring();
              this.realtimeQueries.scheduled_recurring = null
              this.queried.scheduled_recurring = [];
            }
            this.realtimeQueries.scheduled_recurring = this.$firestore.collection('scheduled_recurring').onSnapshot(snapshot => {
              if(!this.queried.scheduled_recurring){
                this.queried.scheduled_recurring = [];
              }
              snapshot.docChanges().forEach(change => {
                let schedule = change.doc.data();
                console.log('change');
                if(change.type === "removed"){
                  let index = this.queried.scheduled_recurring.findIndex(v => v.id === change.doc.id);
                  this.queried.scheduled_recurring.splice(index, 0);
                }else if(change.type === "modified"){
                  console.log('modded');
                  let index = this.queried.scheduled_recurring.findIndex(v => v.id === change.doc.id);
                  this.$set(this.queried.scheduled_recurring,index, {id: change.doc.id, ...schedule});
                }else if(change.type === "added"){
                  this.queried.scheduled_recurring.push({id: change.doc.id, ...schedule})
                }
              })
            })
          },
          listenToRoutes(){
              if(this.realtimeQueries.routes){
                this.realtimeQueries.routes();
                this.realtimeQueries.routes = null
                this.queried.routes = [];
              }
              this.realtimeQueries.routes = this.$firestore.collection('routes').onSnapshot(snapshot => {
                  if(!this.queried.routes){
                      this.queried.routes = [];
                  }
                  snapshot.docChanges().forEach(change => {
                      let route = change.doc.data();
                      if(change.type === "removed"){
                          let index = this.queried.routes.findIndex(v => v.id === change.doc.id);
                          this.queried.routes.splice(index, 0);
                      }else if(change.type === "modified"){
                          let index = this.queried.routes.findIndex(v => v.id === change.doc.id);
                          this.$set(this.queried.routes,index, {id: change.doc.id, ...route});
                      }else if(change.type === "added"){
                          this.queried.routes.push({id: change.doc.id, ...route})
                      }
                  })
              })

          },
            setToday(){
                this.focus = this.today;
            },
            prevMonth(){
                this.$refs.calendar.prev();
            },
            nextMonth(){
                this.$refs.calendar.next();
            },
            scheduledCustomerName(id){
                let name = this.queried.names.filter(v => v.customer_id ===  id);
                return name.length > 0 ? name[0].name : "Not Synced";
            },
            scheduledCustomers(id){
                console.log(this.focus);
                let scheduled = this.queried.scheduled.filter(v => (v.route_id === id && v.date === this.focus));
                let scheduledRecurring = this.queried.scheduled_recurring.filter(v => (v.route_id === id && v.days[this.day]));
                return [...scheduled, ...scheduledRecurring];
            }
        },
        beforeRouteLeave(to, from, next){
            if(this.realtimeQueries.routes) this.realtimeQueries.routes();
            if(this.realtimeQueries.scheduled) this.realtimeQueries.scheduled();
            if(this.realtimeQueries.scheduled_recurring) this.realtimeQueries.scheduled_recurring();
            next();
        }
    }
</script>

<style scoped>

</style>
